import React from "react";
import { Empty } from "antd";
import { ReactComponent as EmptyIllustration } from "../assets/images/noRecord.svg";

interface CustomEmptyProps {
  message?: string;
}

const CustomEmpty: React.FC<CustomEmptyProps> = ({ message }) => {
  return (
    <Empty
      image={<EmptyIllustration />} // ✅ Correct: SVG as React component
      description={
        <span className="text-gray-500 text-sm">
          {message || "No data available"}
        </span>
      }
      imageStyle={{ height: 120 }}
    />
  );
};

export default CustomEmpty;
